import React, { useEffect, useState } from 'react'
import Button from '../../components/button'

import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/pagination'
import { Pagination } from 'swiper'

// redux
import { mapDispatchProps, mapStateToProps } from '../../store/store'
import { connect } from 'react-redux'
import { useLanguage } from '@languages/index';

function useForceUpdate() {
  const [value, setValue] = useState(0)
  return () => setValue((value) => value + 1)
}

const Image = (props: any) => {
  const language = useLanguage();   
  const languageTexts = { ...language.common, ...language.pages.image };
  const forceUpdate = useForceUpdate()
  const [currentIndex, setCurrentIndex] = useState(0)
  const [images, setImages] = useState([])
  const [maxHeight, setMaxHeight] = useState(0)

  const downloadImage = () => {
    const link = document.createElement('a')
    link.href = `/api/posting/download?brand_token=${props.auth.token}&download=${images[currentIndex].id}`
    link.click()
  }

  const firstImage = props.firstImage
    ? props.images.filter((image) => {
        return image.id === props.firstImage.id
      })
    : []

  const restImage = props.firstImage
    ? props.images.filter((image) => {
        return image.id !== props.firstImage.id
      })
    : props.images

  useEffect(() => {
    setImages([...firstImage, ...restImage])
  }, [])

  const onImgLoad = ({ target: img }) => {
    const { offsetHeight, offsetWidth } = img

    setTimeout(() => {
      if (offsetHeight > maxHeight) {
        setMaxHeight(offsetHeight)
      }
    }, 100)
  }

  useEffect(() => {
    forceUpdate()
  }, [maxHeight])

  return (
    <div className="w-full h-full">
      <Swiper
        pagination={{
          dynamicBullets: true,
        }}
        navigation={true}
        modules={[Pagination]}
        onSlideChange={(data) => {
          setCurrentIndex(data.activeIndex)
        }}
      >
        {images.map((image: any) => {
          return (
            <SwiperSlide key={`PostingImage${image.id}`}>
              <img
                onLoad={onImgLoad}
                className="w-full h-full"
                style={{
                  minWidth: '440px',
                  objectFit: 'cover',
                  aspectRatio: '0.785',
                }}
                src={image.src}
              />
            </SwiperSlide>
          )
        })}
      </Swiper>
      {props.isDownloadable ? (
        <Button
          buttonColor={'#FFBC64'}
          borderColor={'#FFBC64'}
          textColor={'WHITE'}
          text={languageTexts.index_text_1}
          onClick={() => {
            downloadImage()
          }}
        />
      ) : null}
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(Image)
